import { useState, useEffect } from 'react';
import PersonnelVoipManagement from './personnelVoipManagement';
import AnonymousCalls from './AnonymousCalls';

export interface InputProps {
  permission: any,
  labId:any
}

const VoipManagement = ({permission,labId}: InputProps) => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (id: any) => {
    setActiveTab(id);
  };
  useEffect(() => {
  }, [])
  return (
    <>
      {permission && (
        <div>
          <ul className="inner-tabs" style={{ justifyContent: 'center' }}>
            <li className={activeTab === 1 ? 'financialRepTabActive' : 'financialRepTab'} onClick={() => handleTabClick(1)}>  صفحه مدیریتی ویپ پرسنل </li>
            <li className={activeTab === 2 ? 'statisticalRepTabActive' : 'statisticalRepTab'} onClick={() => handleTabClick(2)}>لیست تماس های ناشناس </li>
          </ul>

          <div className="inner-tabs_content">
            {
              activeTab === 1 && <div className="tab_panel">
                <PersonnelVoipManagement labId={labId}/>
              </div>
            }
            {activeTab === 2 && <div className="tab_panel"><AnonymousCalls labId={labId} /> </div>}

          </div>
        </div>
      )}
      {!permission && (
        <center style={{ padding: '30px' }}> <span style={{ color: 'red', paddingTop: '20px' }}>شما به اطلاعات این صفحه دسترسی ندارید!</span></center>
      )}
    </>
  );
};

export default VoipManagement;